var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgFolderAdd = function SvgFolderAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 19h-17V6h5.172l2.12 2.121A3 3 0 0012.915 9H20.5v10zm-19 1V5a1 1 0 011-1h6.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293H21.5a1 1 0 011 1v12a1 1 0 01-1 1h-19a1 1 0 01-1-1zm9.5-3v-2H9v-2h2v-2h2v2h2v2h-2v2h-2z",
    fill: "#9CA6AD"
  })));
};

export default SvgFolderAdd;